export const useFeedRefreshReadItems = () => {
  const feedStore = useFeedStore();

  const feeds = computed(() => feedStore.feeds);

  const refreshReadItems = async () => {
    const ids = feeds.value
      .filter(
        (feed) => (!feed.read && !feed?.actions?.length) || !feed?.isRequest
      )
      .map((feed) => feed.id);
    await useFeedPostReadIds(ids);
  };
  return {
    refreshReadItems,
  };
};
